export default class PrimaryUrlService {

    defaultUrl = '/';
    key = 'primary-url';

    storeUrl() {
        sessionStorage.setItem(this.key, window.location.pathname + window.location.search);
    }

    restoreUrl() {
        const url = sessionStorage.getItem(this.key) || this.defaultUrl;
        sessionStorage.removeItem(this.key);

        return url;
    }
}
